import React, { createContext, useState, useEffect } from 'react';
import axios from 'axios';
import { config } from '../config';

export const ProductContext = createContext();

export const ProductProvider = ({ children }) => {
  const apiUrl = config.apiUrl;
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [banners, setBanners] = useState([]);
  const [pixel, setPixel] = useState([]);
  const [footerMenus, setFooterMenus] = useState([]);
  const [contactInfo, setContactInfo] = useState({});
  const [logo, setLogo] = useState({});
  const [socialLinks, setSocialLinks] = useState([]);
  const [coinBonus, setCoinBonus] = useState({});
  const [coinPackages, setCoinPackages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filteredProducts, setFilteredProducts] = useState([]);

  const [testEventCode, setTestEventCode] = useState([])

  // সমস্ত ডেটা একসাথে ফেচ করার ফাংশন - শুধু ১টি API call
  const fetchAllData = async () => {
    try {
      setLoading(true);
      setError(null);
      
      // শুধু ১টি API call
      const response = await axios.get(`${apiUrl}/homepage-data`);
      const responsePixel = await axios.get(`${apiUrl}/pixels`);
      
      if (response.data.success) {
        const data = response.data.data;

        // সব ডেটা একসাথে set করুন
        setProducts(data.products || []);
        setCategories(data.categories || []);
        setBanners(data.banners || []);
        setFooterMenus(data.footer_menus || []);
        setContactInfo(data.contact_info || {});
        setLogo(data.logo || {});
        setSocialLinks(data.social_links || []);
        setCoinBonus(data.coin_bonus || {});
        setCoinPackages(data.coin_packages || []);
        
        setPixel(responsePixel.data.pixels?.map((p) => p.pixel_id) || []);
        setTestEventCode(responsePixel.data.pixels?.map((p) => p.test_event_code) || []);
      } else {
        throw new Error(response.data.message || 'Failed to fetch data');
      }
    } catch (err) {
      console.error('Error fetching homepage data:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllData();
  }, [apiUrl]);

  const filterProductsByCategory = (categoryId) => {
    const filtered = products.filter(
      (product) => product.category_id === categoryId
    );
    setFilteredProducts(filtered);
  };



  return (
    <ProductContext.Provider
      value={{
        // Existing data
        products,
        filteredProducts,
        categories,
        pixel,
        testEventCode,
        banners,
        loading,
        setLoading,
        error,
        
        // New data from consolidated API
        footerMenus,
        contactInfo,
        logo,
        socialLinks,
        coinBonus,
        coinPackages,
        filterProductsByCategory,
        
        // Methods
        refetchData: fetchAllData,
        apiUrl
      }}
    >
      {children}
    </ProductContext.Provider>
  );
};
